import React, { useState, useEffect, useRef } from 'react';
import * as classnames from 'classnames';
import InputMask from 'react-input-mask';
import DatePicker from 'react-date-picker';

import { Pencil, Check } from '../../static';
import Label from './Label';

import './styles.scss';

const Input = ({ 
	id,
	value, 
	label,
	type,
	onChange,
	required,
	placeholder = ' ',
	isEdit,
	onClick,
	isFileStyle,

	isPlaceholder,
	isCard,
	mask = "0",
}) => {
	const [edit, setEdit] = useState(false);
	const [date, setDate] = useState(value);
	const [validExpiration, setValidExpiration] =useState({
		firsnNum: false,
		secondNum: false,
		firstActive: false
	})
	const changeExpiration = useRef(true)


	const handleChangeInput = ({target}) => {

		if(isCard && mask === "99/99") {
			checkExpiration(target.value);
		}

		if(typeof onChange === 'function') {
			if(isCard) {

				if(changeExpiration.current) {
					onChange(target, true); 
				} else {
					onChange(target, false); 
				}

			} else {
				onChange(target); 
			}
		};
	};

	const checkExpiration = (value) => {
		const month = value.split("")

		if(validExpiration.firstActive) {
			if(!isNaN(Number(month[0])) && Number(month[0]) <= 1 ) {
				changeExpiration.current = true
				setValidExpiration(prev => ({...prev,firsnNum: false}))
			} 

			if(!isNaN(Number(month[0])) && Number(month[0]) > 1 ) {
				changeExpiration.current = false
				setValidExpiration(prev => ({...prev,firsnNum: true}))
			} 
			
			if(!isNaN(Number(month[1]))) {

				if(Number(month[0]) === 0 && Number(month[1]) === 0) {
					setValidExpiration(prev => ({...prev,secondNum: true}))
					changeExpiration.current = false
				} 

				if(Number(month[0]) === 0 && Number(month[1]) !== 0) {
					setValidExpiration(prev => ({...prev,secondNum: false}))
					changeExpiration.current = true
				} 

				if(Number(month[0]) !== 0 && Number(month[1]) <=2 ) {
					setValidExpiration(prev => ({...prev,secondNum: false}))
					changeExpiration.current = true
				} 

				if(Number(month[0]) !== 0 && Number(month[1]) >=3 ) {
					setValidExpiration(prev => ({...prev,secondNum: true}))
					changeExpiration.current = false
				}
				
			} 
		} else {
			setValidExpiration(prev => ({...prev,firstActive: true}))
		}

	}

	const handleClick = () => {
		onClick({id, edit});
		setEdit(!edit)
	};

	const handleChangeDate = (date, e) => {
		setDate(date)
		onChange( {id, value: date});
	};

	useEffect(() => {
		if(type === "date") {
			setDate(value)
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[value]);

	if(type === 'email') {
		if(typeof value !== 'string') {
			value = '';
		}
	}

	if(isCard) {
		return (
			<div 
				className={
					classnames('input-group', {
						'input-group--isPlaceholder': isPlaceholder,
						'input-group--validExpiration': validExpiration.firsnNum || validExpiration.secondNum,
					})
				}
			>
				<InputMask 
					id={id}
					mask={mask}
					onChange={handleChangeInput} 
					value={value} 
					placeholder={placeholder}
				/>
				{label && <Label label={label} required={required}/>}
			</div>
		)
	}

	if(type === "checkbox" && id === 'isImmunity') {
		return (
			<div 
				className={classnames('input-group input-group-checkbox',{
				})}
			>
				<div 
					className={classnames('input-group-checkbox__button',{
						'input-group-checkbox__button--active': value
					})}
				>
					<input 
						type={type} 
						id="on"
						name={id}
						onChange={handleChangeInput}
						defaultChecked={value}
								
					/>	
					<label 
						className={classnames('input-group-checkbox__label',{
							'input-group-checkbox__label--active': value
						})}
						htmlFor="on"
						>
						<div 
						
						className={classnames('input-group-checkbox__circle',{
							'input-group-checkbox__circle--active': value
						})}
						>

						</div>

					</label>
				</div>
				<div className="input-group-checkbox__text">
					{label}
				</div>

			</div>
		)
	}

	if(type === "checkbox") {
		return (
			<label className="input-group input-group--checkbox">
				<input 
					id={id} 
					type={type}
					onChange={handleChangeInput}
				/>
				{label && <span className="input-group__checkbox-text">{label}</span>}	
			</label>
		);
	};

	if(type === "textarea") {
		return (
			<div className="input-group input-group--textarea">
				<textarea 
					id={id} 
					onChange={handleChangeInput}
					placeholder={placeholder}

				/>
			</div>
		);
	};

	if(type === "file") {
		return (
			<div 
				className={classnames('input-group input-group-file',{
					'input-group-file--style': isFileStyle
				})}
			>
				<Pencil />
				<input 
					id={id} 
					type={type}
					onChange={handleChangeInput}
				/>
				{label && <span className="input-group-file__text">{label}</span>}	
			</div>
		);
	};

	if(type === "radio") {
		return (
			<div 
				className={classnames('input-group input-group-radio',{
					// 'input-group-file--style': isFileStyle
				})}
			>

				{label && <h2 className="input-group-radio__title">{label}</h2>}	

				<div className="input-group-radio__check-boxs">

					<div className="input-group-radio__check-box">
						<input 
							type={type} 
							id="on"
							name={id}
							value={true} 						
							onChange={handleChangeInput}
							defaultChecked
							
						/>	
						<label htmlFor="on">On</label>
					</div>

					<div className="input-group-radio__check-box">
						<input 
							type={type} 
							id="of"
							name={id}
							value={false} 						
							onChange={handleChangeInput}
							
						/>
						<label htmlFor="of">Of</label>
					</div>

				</div>
				
				
			</div>
		);
	};

	if(type === "tel") {
		return (
			<div 
				className={
					classnames('input-group', {
						'input-group--isRounded': !label,
					})
				}
			>	
				{isEdit ? (
					<>
						<div 
							className="input-group__icon"
							onClick={handleClick}
						>
							{!edit ? <Pencil /> : <Check />}
						</div>
						<InputMask 
							mask="999-999-9999" 
							type={type} 
							id={id}
							value={value} 
							placeholder={placeholder}
							onChange={handleChangeInput}
							className="input-group__input"
							required={required}
							disabled={!edit}
						/>
						{label && <Label label={label} required={required}/>}
					</>
				) : (
					<>
						<InputMask 
							mask="999-999-9999" 
							type={type} 
							id={id}
							value={value} 
							placeholder={placeholder}
							onChange={handleChangeInput}
							className="input-group__input"
							required={required}

						/>
						{label && <Label label={label} required={required}/>}
					</>
				)
				}
			</div>
		);
	};

	if(type === "date") {
		return (
			<div 
				className={
					classnames('input-group input-group-date', {
						'input-group--isRounded': !label,
					})
				}
			>	
				{isEdit ? (
					<>
						<div 
							className="input-group__icon"
							onClick={handleClick}
						>
							{!edit ? <Pencil /> : <Check />}
						</div>
						<DatePicker
							onChange={handleChangeDate}
							value={date}
							className="input-group__input"
							disableCalendar
							maxDate={new Date(2100, 1, 31)}
							disabled={!edit}
						/>
						{label && <Label label={label} required={required}/>}
					</>
				) : (
					<>	
						<DatePicker
							onChange={handleChangeDate}
							value={date}
							className="input-group__input"
							disableCalendar
							disabled={false}
							maxDate={new Date(2100, 1, 31)}
						/>

						{label && <Label label={label} required={required}/>}
					</>
				)
				}
			</div>
		);
	};

	if(isEdit) {
		return (
			<div 
				className={
					classnames('input-group input-group--edit', {
						'input-group--isRounded': !label,
					})
				}
			>
				<div 
					className="input-group__icon"
					onClick={handleClick}
				>
					{!edit ? <Pencil /> : <Check />}
				</div>
				<input className="input-group__input"
					value={value}
					type={type} 
					id={id} 
					placeholder={placeholder}
					onChange={handleChangeInput}
					required={required}
					disabled={!edit} 
					ref={input => input && input.focus()}
				/>
				{label && <Label label={label} required={required}/>}
			</div>
		);
	};

	return (
		<div 
			className={
				classnames('input-group', {
					'input-group--isRounded': !label,
					'input-group--isPlaceholder': isPlaceholder,
				})
			}
		>
			<input className="input-group__input"
				value={value}
				type={type} 
				id={id} 
				placeholder={placeholder}
				onChange={handleChangeInput}
				required={required}
				autoComplete="of"
			/>
			{label && <Label label={label} required={required}/>}
		</div>
	);
};

export default Input;
